<h1 matDialogTitle> {{ 'popup.confirm' | translate }} </h1>
<div mat-dialog-content [innerHTML]="confirmMessage | translate | htmlWithStyle"></div>
<div mat-dialog-actions class="pt-24">
    <button mat-button (click)="dialogRef.close(false)" aria-label="confirm_popup_cancel_button">{{ 'popup.cancel' | translate }}</button>
    <button mat-raised-button class="mat-accent mr-16" aria-label="confirm_popup_confirm_button" (click)="dialogRef.close(true)">{{ 'popup.confirm' | translate }}</button>
</div>
